// Progressive enhancement: native links and disclosure remain usable without JavaScript.
const mobile = window.matchMedia('(max-width: 599px)');

function navigation() {
    return {
        toggle: document.querySelector('.menu-toggle'),
        nav: document.getElementById('site-navigation')
    };
}

function closeNavigation(restoreFocus = false) {
    const { toggle, nav } = navigation();
    if (!toggle || !nav) return;
    if (restoreFocus) toggle.focus();
    toggle.setAttribute('aria-expanded', 'false');
    nav.hidden = mobile.matches;
}

function initializeNavigation() {
    const { toggle, nav } = navigation();
    if (!toggle || !nav) return;
    toggle.hidden = !mobile.matches;
    nav.dataset.enhanced = 'true';
    if (mobile.matches && nav.contains(document.activeElement)) toggle.focus();
    closeNavigation();
}

function closePracticeMenus(except = null) {
    document.querySelectorAll('.practice-menu[open]').forEach(menu => {
        if (menu !== except) menu.open = false;
    });
}

document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const { toggle, nav } = navigation();
    if (toggle && event.target.closest('.menu-toggle')) {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (nav) nav.hidden = expanded;
        if (expanded) closePracticeMenus();
        return;
    }
    closePracticeMenus(event.target.closest('.practice-menu'));
    const link = event.target.closest('a[href^="#"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    closePracticeMenus();
    closeNavigation();
    // Keep native hash history and scrolling; put keyboard focus at the destination.
    requestAnimationFrame(() => target.focus({ preventScroll: true }));
});

document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openPractice = document.querySelector('.practice-menu[open]');
    if (openPractice) {
        openPractice.open = false;
        openPractice.querySelector('summary').focus();
        event.preventDefault();
        return;
    }
    const { toggle } = navigation();
    if (toggle?.getAttribute('aria-expanded') === 'true') {
        closeNavigation(true);
        event.preventDefault();
    }
});

document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element)) return;
    closePracticeMenus(event.target.closest('.practice-menu'));
});

mobile.addEventListener('change', initializeNavigation);
initializeNavigation();
